import type { RootState } from '@/_store/store';

export const selectShowSubmenu = (state: RootState) => state.layout.showSubmenu;
export const selectMenuOpened = (state: RootState) => state.layout.menuOpened;
export const selectRouteActive = (state: RootState) => state.layout.routeActive;
export const selectShowJson = (state: RootState) => state.layout.showJson;
export const selectEventModalData = (state: RootState) =>
  state.layout.eventModalData;
